import React, {
  useCallback,
  useState,
} from 'react';

import getAppStores from '../../utils/appStores';
import config from '../../config';

import GooglePlayBadge from '../../assets/google-play-badge.png';

import texts from './texts.json';

import {
  Container,
  Message,
  ButtonsContainer,
  StoreBadge,
} from './styles';

const storePlatformConfig = {
  ios: {
    storeName: 'App Store',
    storeURL: config.storeURLs.ios,
    badge: 'https://developer.apple.com/assets/elements/badges/download-on-the-app-store.svg',
  },
  android: {
    storeName: 'Play Store',
    storeURL: config.storeURLs.android,
    badge: GooglePlayBadge,
  },
};

const DownloadApp = () => {
  const [storesConfig] = useState(() => getAppStores().map((store) => storePlatformConfig[store]));

  const renderDownloadButtons = useCallback(() => (
    storesConfig.map((storeConfig) => {
      const {
        storeURL,
        storeName,
        badge,
      } = storeConfig;
      return (
        <StoreBadge
          key={storeName}
          src={badge}
          alt={`Download on the ${storeName}`}
          onClick={() => window.open(storeURL, '_blank')}
        />
      );
    })
  ), [
    storesConfig,
  ]);

  return (
    <Container>
      <Message>{texts.getTheApp}</Message>
      <ButtonsContainer>
        {renderDownloadButtons()}
      </ButtonsContainer>
    </Container>
  );
};

export default DownloadApp;
